export default __webpack_public_path__ + "static/media/mongodb.0fb5f1e3.svg";